import * as Ramda from 'ramda';
import qs from 'qs';
import type { FilterFormFields } from './FilterModal';

const stringifyQuery =
  (currentQuery: Query['f']) => (query: FilterFormFields['filters']) => {
    const nextQ = query.reduce<Query>(
      (acc, filter) => {
        return {
          ...acc,
          f: {
            ...acc.f,
            [filter.columnName.value]: {
              [filter.operator]: filter.value,
            },
          },
        };
      },
      { f: currentQuery }
    );

    return qs.stringify(nextQ, { encode: false, arrayFormat: 'comma' });
  };

const flattenQuery = (queryString: string) => {
  return qs.parse(queryString, { ignoreQueryPrefix: true });
};

export const prepQueryFilters = (currQuery: Query['f']) =>
  Ramda.compose(flattenQuery, stringifyQuery(currQuery));

/* types */
interface Query {
  f: {
    [columnName: string]: {
      [operator: string]: string;
    };
  };
}
